<template>
  <v-dialog
      v-model="dialog"
      max-width="610"
  >
    <v-card v-if="order.id">
      <v-card-title class="headline">
        Заказ № {{ order.id }}
      </v-card-title>
      <v-icon class="check-in-iiko" v-if="order.iiko_id">mdi-check</v-icon>
      <v-icon class="check-in-iiko" v-if="order.is_first_order" style="right: 74px;">mdi-new-box</v-icon>
      <span v-if="order.type_id === 3 && !order.is_payed" class="red-circle"></span>
      <v-card-text class="order-modal">
        <div v-if="order.type_id == 3">
          Статус оплаты {{ order.online_pay_account ? order.online_pay_account.name : '' }}: {{ order.pay_status }}
          <v-btn :loading="loadingButton" @click="updatePayStatus" small
                 style="padding: 6px!important; height: 24px!important; min-width: 24px!important; float: right;">
            <v-icon x-small>mdi-refresh</v-icon>
          </v-btn>
        </div>
        <div class="client-info">
          {{ order.client_name }} ( ID: <router-link :to="{ name: 'user-edit', params: { id: order.client_id } }">{{ order.client_id}}</router-link> ) <span class="error--text font-weight-bold">{{order.no_cash_payment ? 'Только предоплата' : ''}}</span><br>
          {{ order.client_email }}<br>
          {{ order.phone }}<br>
          {{ order.address }}
        </div>
        <div v-for="orderItem in order.order_items" class="order-item">
          <div class="main">
            <div class="name">{{ orderItem.product.name_ua }} ( {{ orderItem.count }} шт )</div>
            <div class="price">{{ orderItem.price * orderItem.count }} UAH</div>
          </div>
          <div class="sub">
          </div>
          <div class="addons">
            <ul>
              <template v-if="orderItem.params && orderItem.params.custom">
                <li v-if="modifier.count > 0" v-for="modifier in orderItem.params.modifiers">
                  <div class="name">+ {{ modifier.modifier.name_ua }}</div>
                  <div class="price">+ {{ modifier.price }} UAH</div>
                </li>
                <template v-for="modGroup in orderItem.params.modifiers_group">
                  <li v-for="modifier in modGroup.modifiers" v-if="modifier.count > 0">
                    <div class="name">+ {{ modifier.name_ua }}</div>
                    <div class="price">+ {{ modifier.pivot.price }} UAH</div>
                  </li>
                </template>
              </template>
              <template v-else v-for="modGroup in orderItem.params">
                <template v-if="modGroup">
                <li v-for="modifier in modGroup.modifiers" v-if="modifier.count > 0">
                  <div class="name">+ {{ modifier.name_ua }} ({{ modifier.count }} шт)</div>
                  <div class="price">+ {{ modifier.pivot.price * modifier.count }} UAH</div>
                </li>
                </template>
              </template>
            </ul>
          </div>
        </div>
        <div v-if="order.delivery_cost > 0" class="order-item">
          <div class="main">
            <div class="name">Доставка </div>
            <div class="price">{{ order.delivery_cost }} UAH</div>
          </div>
        </div>
        <div class="order-item" v-if="order.coupon">
          <div class="main">
            <div class="name">{{ order.coupon }}</div>
            <div class="price">Промокод</div>
          </div>
        </div>
        <template v-if="order.cutlery_items && order.cutlery_items.length">
          <div v-for="(item, index) in order.cutlery_items" :key="index" class="order-item">
            <div class="main">
              <div class="name">{{ item.name }} ( {{ item.pivot.count }} шт )</div>
              <div class="price">{{ parseInt(item.pivot.price) }} UAH</div>
            </div>
          </div>
        </template>
        <div class="order-item">
          <div class="main">
            <div class="name">Приборы {{ order.no_cutlery ? 0 : order.cutlery_count }} шт <span v-if="order.no_cutlery">( кол-во персон: {{ order.cutlery_count }} )</span></div>
            <div class="price">0 UAH</div>
          </div>
        </div>
        <div class="summary">
          Тип оплаты: {{ order.type_text }}<br>
          Цена: {{ order.sum }}<br>
          <template v-if="order.bonus">
            Бонусы: -{{ order.bonus }}<br>
          </template>
          <div class="total">Итого: <b>{{ order.sum - order.bonus }} UAH</b></div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-menu
            top
            close-on-click
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-if="!order.iiko_id && !order.is_processed"
                   :loading="loading"
                   v-bind="attrs"
                   class="mr-3"
                   v-on="on"
            >
              Отправить в айко
            </v-btn>
          </template>

          <v-list>
            <v-list-item style="cursor: pointer">
              <v-list-item-title @click="sendToIiko(null)">Отправить в айко</v-list-item-title>
            </v-list-item>
            <v-list-item v-for="terminal in terminals" :key="terminal.id" style="cursor: pointer">
              <v-list-item-title @click="sendToIiko(terminal.id)" >Отправить в айко: {{ terminal.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
            outlined
            @click="dialog = false; order = {}"
        >
          Закрыть
        </v-btn>

        <v-checkbox class="ml-12" @click="toggleIsProcessed(order)" v-model="order.is_processed"
                    label="Обработан"></v-checkbox>
        <v-checkbox class="ml-6" @click="toggleIsPaid(order)" v-model="order.is_payed" label="Оплачен"></v-checkbox>
        <v-icon v-if="order.iiko_id" large class="iiko-report-btn" @click="openIikoReport">mdi-progress-download</v-icon>
        <v-btn
            v-if="canCreateCheckboxReceipt"
            :loading="loadingCheckbox"
            color="success"
            class="checkbox-receipt-btn"
            @click="createCheckboxReceipt"
        >
          Создать чек Checkbox
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import OrderService from './../api/OrderService'
import moment from 'moment'

export default {
  name: 'OrderModal',
  props: {
    value: Object,
    terminals: Array
  },
  components: {},
  data() {
    return {
      dialog: false,
      loading: false,
      loadingButton: false,
      loadingCheckbox: false,
      order: this.value,
    };
  },
  computed: {
    canCreateCheckboxReceipt() {
      if (!this.order.id || this.order.checkbox_receipt_id || !this.order.created_at || this.order.source !== 'Glovo') {
        return false
      }

      const createdAt = moment(this.order.created_at)
      const now = moment()
      const diffMinutes = now.diff(createdAt, 'minutes')

      return diffMinutes > 10
    }
  },
  methods: {
    openIikoReport() {
      OrderService.getIikoReport(this.order.id).then(response => {
        var myjson = JSON.stringify(response.data, null, 2);
        var x = window.open();
        x.document.open();
        x.document.write('<html><body><pre>' + myjson + '</pre></body></html>');
        x.document.close();
      })
    },
    updatePayStatus() {
      this.loadingButton = true
      OrderService.updatePayStatus(this.order.id).then(response => {
        this.order.pay_status = response.data.pay_status
        this.loadingButton = false
      })
    },
    toggleIsProcessed(item) {
      OrderService.toggleIsProcessed(item.id).then(response => {
        this.order.is_processed = response.data.is_processed
      })
    },
    toggleIsPaid(item) {
      OrderService.toggleIsPaid(item.id).then(response => {
        this.order.is_payed = response.data.is_payed
      })
    },
    sendToIiko: function (terminalId) {
      this.loading = true
      OrderService.sendToIiko(this.order.id, terminalId).then(response => {
        this.order.iiko_id = response.data.iiko_id
      }).finally(() => {
        this.loading = false
      })
    },
    createCheckboxReceipt() {
      this.loadingCheckbox = true
      OrderService.createCheckboxReceipt(this.order.id).then(response => {
        this.$set(this.order, 'checkbox_receipt_id', response.data.checkbox_receipt_id)
      }).catch(error => {
        let message = 'Ошибка при создании чека'
        if (error.response && error.response.data && error.response.data.message) {
          message = error.response.data.message
        }
        alert(message)
      }).finally(() => {
        this.loadingCheckbox = false
      })
    }
  },
  mounted() {

  },
  watch: {
    order(val) {
      if (val.id) {
        this.dialog = true
      } else {
        this.dialog = false
      }

      this.$emit('input', val);
    },
    value(val) {
      if (val.id) {
        this.dialog = true
        if (!val.open_at) {
          OrderService.setOpen(val.id);
        }
      } else {
        this.dialog = false
      }

      this.order = val;
    },
    dialog(val) {
      if (!val) {
        this.order = {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox-receipt-btn{
  position: absolute;
  left: 30px;
  bottom: 200px;
}
.iiko-report-btn{
  position: absolute;
  left: 30px;
  bottom: 140px;
  cursor: pointer;
  &:hover{
    opacity: .6;
  }
}
.client-info {
  margin-bottom: 44px;
}

.check-in-iiko {
  position: absolute;
  right: 32px;
  top: 32px;
  color: green;
}

.red-circle {
  position: absolute;
  top: 32px;
  right: 64px;
}

.order-modal {
  .summary {
    text-align: right;
    font-size: 16px;
    color: #212529;
    border-top: 1px solid #EAF0F6;
    padding: 44px 0;
    border-bottom: 1px solid #EAF0F6;
    line-height: 26px;

    .total {
      margin-top: 16px;
      font-size: 22px;
    }
  }

  .order-item {
    padding: 16px 0;
    border-top: 1px solid #EAF0F6;
  }

  .main {
    display: grid;
    grid-template-columns: 1fr 110px;
    margin-bottom: 4px;
    font-size: 16px;
    line-height: 22px;
    font-weight: bold;

    .name {
    }

    .price {
      text-align: right;
    }
  }

  ul {
    li {
      display: grid;
      grid-template-columns: 1fr 110px;
      font-weight: normal;
      color: #8C959D;
      margin-bottom: 4px;

      .name {
        line-height: 22px;
        font-weight: normal;
        color: #8C959D;
        padding-left: 0;
      }

      .price {
        text-align: right;
      }
    }
  }
}
</style>
